import { TextField as MuiTextField } from "@material-ui/core";
import { rv } from "../../tokens";
import FieldShell from "./FieldShell";

interface Props {
  label?: string;
  value: string | number | undefined;
  onChange: (value: string) => void;
  error?: string;
  required?: boolean;
  // PH ZIP is exactly 4 digits; allow more chars for non-PH addresses.
  philippines?: boolean;
}

export default function ZipField({
  label,
  value,
  onChange,
  error,
  required,
  philippines = true,
}: Props) {
  return (
    <FieldShell label={label} required={required} error={error}>
      <MuiTextField
        variant="outlined"
        size="small"
        fullWidth
        value={value ?? ""}
        error={Boolean(error)}
        inputProps={{
          inputMode: philippines ? "numeric" : "text",
          maxLength: philippines ? 4 : 12,
          style: { fontFamily: rv.fontSans },
        }}
        onChange={(event) => {
          const next = philippines
            ? event.target.value.replace(/\D/g, "").slice(0, 4)
            : event.target.value;
          onChange(next);
        }}
      />
    </FieldShell>
  );
}
